module.exports = __webpack_public_path__ + "img/fixed.174320cb.svg";